import { render } from "./LayoutMaster.vue?vue&type=template&id=ff7777fe"
import script from "./LayoutMaster.vue?vue&type=script&lang=js"
export * from "./LayoutMaster.vue?vue&type=script&lang=js"

import "./LayoutMaster.vue?vue&type=style&index=0&id=ff7777fe&lang=css"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__